export const ENTER_KEY_CODE = 13;
export const SPACE_KEY_CODE = 32;
export const ESC_KEY_CODE = 27;
export const BACK_SPACE_KEY_CODE = 8;
